import { FETCH_CAMPAIGN_SUCCESS } from 'modules/campaigns/actionTypes';
import * as types from 'modules/contactLists/actionTypes';
import { indexByProp } from 'utils/global';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

/** @typedef {import('utils/ReduxUtils').EntitySlice<import('modules/contactLists/types').ContactList>} ContactListDataEntity */

/** @type {import('utils/ReduxUtils').EntityAdapter<import("modules/contactLists/types").ContactList>} */
export const contactListAdapter = createEntityAdapter({ selectId: ({ id }) => id });

const addManyFromPage = (state, { payload: { content } }) => contactListAdapter.updateMany(state, content);

const addFromOtherEntity = (state, { payload }) => {
  if (payload.contactList) {
    return contactListAdapter.updateOne(state, payload.contactList);
  }
  return state;
};

const updateStatisticsFromSocket = (state, { payload: { data, entityId: contactListId } }) =>
  contactListAdapter.updateOne(state, {
    id: contactListId,
    statistics: indexByProp('channel', data.contactListStatistics),
    membersCount: (state.entities[contactListId].membersCount ?? 0) + data.memberIncrement,
  });

export default createReducer(contactListAdapter.getInitialState(), {
  [types.FETCH_CONTACT_LISTS_SUCCESS]: addManyFromPage,
  [types.FETCH_CONTACT_LIST_SUCCESS]: contactListAdapter.addOne,
  [types.CREATE_CONTACT_LIST_SUCCESS]: contactListAdapter.addOne,
  [types.UPDATE_CONTACT_LIST_SUCCESS]: contactListAdapter.updateOne,
  [types.DELETE_CONTACT_LIST_SUCCESS]: contactListAdapter.removeOne,
  [FETCH_CAMPAIGN_SUCCESS]: addFromOtherEntity,
  [types.WS_CONTACT_LIST_STATS_UPDATE]: updateStatisticsFromSocket,
});
